import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";

export const CustomPickList = styled.div`
    .p-button{
        background: ${colors.mainColors.verde_dstore};
        border-color: ${colors.mainColors.verde_dstore};
    }

    .product-details{
        .product-badge{
            background: ${colors.mainColors.verde_dstore};
            padding: 5px 10px;
            color: white;
            border-radius: 5px;
            width: 100%;
            text-align: center;
            font-size: 12px;
                
            &.type-theme{
                background: ${colors.mainColors.roxo_delinea};
            }
        }

        .product-title{
            padding-top: 5px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    

`